// extracted by mini-css-extract-plugin
export default {"title":"UIf_a_bu","text":"zoOoFSjk","inputs":"PcFT1jm7","input":"AE59QGHa","button":"rftnPcXu","wrapper":"luehbVSr","slide":"tDUcgWcj"};